import type React from "react";
import { ReactComponent as Svg } from "./assets/reload-icon.svg";
import * as styles from "./Icon.module.scss";

type ReloadProps = React.SVGProps<SVGSVGElement>;

export const Reload = ({ className, ...props }: ReloadProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
